import React, { useEffect, useRef, useState } from "react";
import { makeStyles, styled } from "@material-ui/core/styles";
import {
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Autocomplete, Stack, tooltipClasses } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestionSetting } from "../../actions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpIcon from "@mui/icons-material/Help";

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
function ConstraintFunction() {
  const { question, questionId } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
  }));
  const dispatch = useDispatch();
  const classes = useStyles();
  return (
    <>
      <FormGroup className={classes.section}>
        <FormControlLabel
          control={
            <Checkbox  />
          }
          label="Enable constraint: "
          style={{marginBottom:0, justifyContent:"space-between"}}
          labelPlacement="start"
          checked={
            question.constraint === ""
              ? false
              : question.constraint || question.constraint.length > 0
          }
          onChange={(e) => {
            dispatch(
              updateQuestionSetting(
                questionId,
                "constraint",
                e.target.checked
              )
            );
          }}
          name={`${questionId}_constraint`}
        />
        {/* {question.constraint || question.constraint.length > 0 && ( */}
        {question.constraint && <ExpressionDialog type="constraint" />}
      </FormGroup>
      <Divider />
    </>
  );
}

export default ConstraintFunction;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="left-start" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#eeeeee",
    color: "#000000",
    maxWidth: 500,
    width: "500px",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
  },
}));

export function ExpressionDialog() {
  const { question, questionId, languages } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    languages: state.languages,
  }));
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const [constraintExpr, setConstraintExpr] = useState(
    question.constraint_expr_syntax
      ? question.constraint_expr_syntax
      : "@@expression@@"
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{textAlign:"center"}}>
      <Button variant="outlined" onClick={handleClickOpen}>
        Custom expression function
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby={`${questionId}_constraint_alert-dialog-description`}
      >
        <DialogTitle>{"Expression constraint "}</DialogTitle>
        <DialogContent style={{height:"400px", overflow:"auto"}}>
          <DialogContentText id={`${questionId}_constraint_alert-dialog-description`}>
            <Stack spacing={2} sx={{ width: 500 }}>
              <RenderExpression
                options={window.ExpressionFunction}
                constraintExpr={constraintExpr}
                setConstraintExpr={setConstraintExpr}
              />
              <Button
                color="error"
                onClick={() => {
                  dispatch(
                    updateQuestionSetting(
                      questionId,
                      "constraint_expr_syntax",
                      null
                    )
                  );
                  setConstraintExpr("@@expression@@");
                }}
              >
                Clear all
              </Button>
              <Typography component="h6" variant="h6" style={{color:"black"}}>
                Constraint message
              </Typography>
              {languages.map((lang) => {
                return (
                  <div key={`${questionId}_constraint_label::${lang}-constraint-wrapper`}>
                    <FormControl
                      key={`${questionId}_constraint_label::${lang}`}
                      required={true}
                      fullWidth={true}
                    >
                      <TextField
                        id={`${questionId}_constraint_constraint_message::${lang}`}
                        name={`${questionId}_constraint_constraint_message::${lang}`}
                        label={`Constraint Message (${lang})`}
                        onChange={(e) => {
                          dispatch(
                            updateQuestionSetting(
                              questionId,
                              `constraint_message::${lang}`,
                              e.target.value
                            )
                          );
                        }}
                        value={question[`constraint_message::${lang}`]}
                        defaultValue={question[`constraint_message::${lang}`]}
                      />
                    </FormControl>
                  </div>
                );
              })}
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              dispatch(
                updateQuestionSetting(
                  questionId,
                  "constraint_expr_syntax",
                  constraintExpr
                )
              );
              let value = constraintExpr
                .replace(/@@|text::/g, "")
                .replace(/##(.*?)##/g, "$1");
              dispatch(
                updateQuestionSetting(questionId, "constraint_expr", value)
              );
              handleClose();
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const RenderExpression = ({ ...props }) => {
  String.prototype.replaceJSX = function (find) {
    let matches = this.match(/@@.*?@@/g);
    return this.split(/@@.*?@@/)
      .flatMap((item, index) => {
        if (matches?.[index]?.indexOf("@@text") > -1) {
          return [
            item,
            <ExpressionText
              index={index}
              constraintExpr={props.constraintExpr}
              setConstraintExpr={props.setConstraintExpr}
              value={matches[index]}
            />,
          ];
        }
        return [
          item,
          <ExpressionFunction
            index={index}
            constraintExpr={props.constraintExpr}
            setConstraintExpr={props.setConstraintExpr}
          />,
        ];
      })
      .slice(0, -1);
  };

  let render = props.constraintExpr.replaceJSX();
  return <>{render}</>;
};
String.prototype.replaceValueText = function (index, value) {
  let matches = this.match(/@@.*?@@/g);
  return this.split(/@@.*?@@/)
    .flatMap((item, i) => {
      if (index === i) {
        if (value === "@@expression@@") {
          return [item, "@@expression@@"];
        } else {
          return [item, value ? `@@text::${value}@@` : "@@text@@"];
        }
      }
      return [item, matches[i]];
    })
    .slice(0, -1);
};

const ExpressionText = ({ ...props }) => {
  const [value, setValue] = useState([]);
  const [valueText, setValueText] = useState([]);
  const { questionsList } = useSelector((state) => ({
    questionsList: state.questionsList,
  }));
  useEffect(() => {
    if (props.value?.match(/@@text::(.*?)@@/)) {
      let value = props.value
        ?.match(/@@text::(.*?)@@/)?.[1]
        .split(" ")
        .map((vl) => {
          if (vl?.indexOf("${") > -1) {
            return {
              FunctionName: vl.match(/\${(.*?)}/)?.[1],
              FunctionSyntax: vl,
            };
          } else if (vl?.indexOf("'") > -1) {
            return {
              FunctionName: vl.match(/\'(.*?)'/)?.[1],
              FunctionSyntax: vl,
            };
          } else if (vl?.indexOf("##") > -1) {
            return {
              FunctionName: vl.match(/\##(.*?)##/)?.[1],
              FunctionSyntax: vl,
            };
          }

          return { FunctionName: vl, FunctionSyntax: vl };
        });
      setValue(value);
    }
  }, []);
  let questionList = Object.values(questionsList).map((ques) => {
    return {
      FunctionName: ques.name,
      FunctionSyntax: "${" + ques.name + "}",
    };
  });
  let options = window.ExpressionFunction?.filter((expression) => {
    if (expression.Enable === "TRUE") {
      return expression;
    }
  });
  return (
    <>
      <div style={{ display: "flex" }}>
        <Autocomplete
          multiple
          options={[...options, ...questionList]}
          getOptionLabel={(option) => option.FunctionName}
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
            setValueText("");
            let values = newValue.map((value) => {
              return value.FunctionSyntax;
            });
            let value = props.constraintExpr.replaceValueText(
              props.index,
              values.join(" ")
            );
            props.setConstraintExpr(value.join(""));
          }}
          filterOptions={(options, params) => {
            const { inputValue } = params;
            if (inputValue?.indexOf("@") > -1) {
              return Object.values(questionsList).map((ques) => {
                return {
                  FunctionName: ques.name,
                  FunctionSyntax: "${" + ques.name + "}",
                };
              });
            } else if (inputValue.length > 0) {
              // // Suggest the creation of a new value
              let filtered = options;
              filtered = filtered.filter((option) => {
                return String(option.FunctionSyntax)?.indexOf("##") > -1;
              });
              const isExisting = options.some(
                (option) => inputValue === option.FunctionName
              );
              if (inputValue !== "" && !isExisting) {
                let value = inputValue;
                if (typeof value == "string") {
                  console.log("value", value, isNaN(value));
                  if (isNaN(value)) {
                    value = inputValue;
                  } else if (value && value.length > 1 && value[0] === "0") {
                    value = `'${inputValue}'`;
                  } else {
                    value = parseFloat(value);
                  }
                } else if (typeof value == "number") {
                  value = inputValue;
                }
                filtered.push({
                  FunctionName: inputValue,
                  FunctionSyntax: value,
                });
              }
              filtered = filtered.filter((option) => {
                return String(option.FunctionSyntax)?.indexOf("${") === -1;
              });
              return filtered;
            } else {
              let filtered = options;
              filtered = filtered.filter((option) => {
                return String(option.FunctionSyntax)?.indexOf("##") > -1;
              });
              return filtered;
            }
          }}
          fullWidth
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              return (
                <Chip
                  variant="outlined"
                  label={option.FunctionName}
                  {...getTagProps({ index })}
                />
              );
            })
          }
          renderInput={(params) => {
            params.inputProps.value = valueText;
            return (
              <TextField
                value={valueText}
                {...params}
                onChange={(e) => {
                  setValueText(e.target.value);
                }}
                fullWidth
                placeholder="Press @ to show list question"
              />
            );
          }}
          renderOption={(props, option, state) => {
            return (
              <li {...props}>
                <span style={{ width: "100%" }}>{option.FunctionName}</span>
                {option.Description && (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <img
                          alt=""
                          src={option.ImageDescription}
                          style={{
                            width: "100%",
                            borderRadius: "4px",
                          }}
                        />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: option.Description,
                          }}
                        ></div>
                      </React.Fragment>
                    }
                  >
                    <span>
                      <HelpIcon color="info" />
                    </span>
                  </HtmlTooltip>
                )}
              </li>
            );
          }}
        />
        <div>
          <IconButton
            onClick={() => {
              let value = props.constraintExpr.replaceValueText(
                props.index,
                "@@expression@@"
              );
              props.setConstraintExpr(value.join(""));
            }}
          >
            <DeleteIcon color="error" />
          </IconButton>
        </div>
      </div>
    </>
  );
};

const ExpressionFunction = ({ ...props }) => {
  const [valueText, setValueText] = useState("");
  const [value, setValue] = useState(null);
  const ref = useRef();
  return (
    <Autocomplete
      options={window.ExpressionFunction?.filter((expression) => {
        if (
          expression.Enable === "TRUE" &&
          expression.FunctionSyntax?.indexOf("##") === -1
        ) {
          return expression;
        }
      })}
      value={value}
      getOptionLabel={(option) => option.FunctionName}
      onChange={(event, newInputValue) => {
        let render = props.constraintExpr.replaceValueExpression(
          props.index,
          newInputValue ? newInputValue.FunctionSyntax : "@@expression@@"
        );
        props.setConstraintExpr(render.join(""));
        setValueText("");
        setValue(null);
      }}
      renderOption={(props, option, state) => {
        return (
          <li {...props}>
            <span style={{ width: "100%" }}>{option.FunctionName}</span>
            {option.Description && (
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <img
                      alt=""
                      src={option.ImageDescription}
                      style={{
                        width: "100%",
                        borderRadius: "4px",
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: option.Description,
                      }}
                    ></div>
                  </React.Fragment>
                }
              >
                <span>
                  <HelpIcon color="info" />
                </span>
              </HtmlTooltip>
            )}
          </li>
        );
      }}
      fullWidth
      renderInput={(params) => {
        params.inputProps.value = valueText;
        return (
          <TextField
            {...params}
            onChange={(e) => {
              setValueText(e.target.value);
            }}
            onClick={() => {
              setValue("");
            }}
            fullWidth
            placeholder="Select function expression"
          />
        );
      }}
    />
  );
};
String.prototype.replaceValueExpression = function (index, value) {
  let matches = this.match(/@@.*?@@/g);
  return this.split(/@@.*?@@/)
    .flatMap((item, i) => {
      if (index === i) {
        return [item, value];
      }
      return [item, matches[i]];
    })
    .slice(0, -1);
};
